export const xlsxPicker = {
	sheetHumanizeErrorMessage: {
		verifyBaseSheet:
			", por favor verifique o modelo da planilha exemplo ou utilize-a como planilha base.",
		unidentifieldColumn: "Erro nos nomes das colunas",
		emptySheet: "Essa planilha está vazia",
		emptySheetRows:
			"Essa planilha está com linhas vazias, por favor remova as linhas vazias.",
		emptyHeaderCell: "Falta nome nas colunas",
		sheetPoorlyFormatted:
			"Formate a planilha para fonte Calibri, tamanho 11, remova os espaços, quebras de linhas desnecessárias e negrito",
		default: "Ocorreu um erro ao importar a planilha",
	},
	sheetNameExample: "(exemplo)",
	sheetNameInvalid: "(inválida)",
	sheetDownload: "Baixar tabela exemplo",
	sheetXlsxPicker: "Escolha uma planilha",
	sheetFeedback: {
		successMessage: "Planílha válida!",
		errorMessage:
			"Planilha inválida, baixe-a novamente e faça as alterações necessárias.",
	},
	duplicateError:
		"Foram identificados valores duplicados na planilha enviada.\n\nPor favor, revise o arquivo, corrija os itens duplicados e envie novamente para continuar.",
	invalidSheetFormat:
		"A planilha enviada possui um modelo inválido para este lugar.\n\nPor favor, utilize o modelo correto baseado no país do lugar e envie novamente.",
	columns: {
		name: "Nome",
		category: "Categoria",
		menuCategory: "Categoria do menu",
		description: "Descrição",
		image: "Imagem",
		hasAlcohol: "Contém álcool?",
		price: "Preço",
		variablePrice: "Preço variável",
		kind: "Tipo de produto",
		fiscalCode: "SKU",
		ncm: "Fiscal - NCM",
		cest: "Fiscal - CEST",
		fiscalProductGroup: "Fiscal - Grupo fiscal",
		fiscalProfile: "Fiscal - Perfil fiscal",
		fiscalIcmsBaseCalculoRetSt: "Base de Cálculo do ICMS Retido na operação anterior",
		fiscalIcmsValorSubistituto: "Valor do ICMS Próprio do Substituto",
		fiscalIcmsAliquotaFinal: "Alíquota Suportada pelo Consumidor Final",
		id: "Id do produto",
		products: "produtos",
		bars: "Bares",
		beerBrand: "Marca da cerveja",
		beerStyle: "Estilo da cerveja",
		beerAbv: "ABV - Teor alcoólico",
		isStockable: "Estocável",
		fileName: "produtos_{{placeName}}",
	},
	cell: {
		trueHasAlcohol: "VERDADEIRO",
		falseHasAlcohol: "FALSO",
	},
};
